<form [formGroup]="formGroup">
  <div class="card-data" formArrayName="target">
    <h4>
      {{ "Resme Target" | translate }}
    </h4>

    <div
      class="row align-items-end"
      *ngFor="let target of targets.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="col p-0 p-md-auto">
        <label>{{ "Position" | translate }}</label>
        <input
          type="text"
          formControlName="name"
          placeholder="{{ 'Position Name' | translate }}"
        />
      </div>
      <div class="col">
        <label>{{ "Description" | translate }}</label>

        <input
          type="text"
          formControlName="description"
          placeholder="{{ 'Description' | translate }}"
        />
      </div>
      <i
        class="col-auto bi bi-trash3 delete-icon"
        *ngIf="this.targets.length > 1"
        (click)="removeTarget(i)"
      ></i>
    </div>

    <button class="border-button" (click)="addTarget()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <div class="next-container px-4">
    <button class="gradient-button m-3" (click)="onNext()">
      {{ "Next" | translate }}
    </button>
  </div>
</form>
